import {DataSource} from "@angular/cdk/collections";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {merge, Observable, of as observableOf} from "rxjs";
import {map} from "rxjs/operators";
import {RentalPropertyModel} from "../../../../../../domain/models/rental-property.model";

export class PropertiesDatasource extends DataSource<RentalPropertyModel> {
  paginator: MatPaginator | undefined;
  sort: MatSort | undefined;

  constructor(public data: RentalPropertyModel[]) {
    super();
  }

  connect(): Observable<RentalPropertyModel[]> {
    if (this.paginator && this.sort) {
      return merge(observableOf(this.data), this.paginator.page, this.sort.sortChange)
        .pipe(map(() => {
          return this.getPagedData(this.getSortedData([...this.data ]));
        }));
    } else {
      throw Error('Please set the paginator and sort on the data source before connecting.');
    }
  }

  disconnect(): void {}

  private getPagedData(data: RentalPropertyModel[]): RentalPropertyModel[] {
    if (this.paginator) {
      const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
      return data.splice(startIndex, this.paginator.pageSize);
    } else {
      return data;
    }
  }

  private getSortedData(data: RentalPropertyModel[]): RentalPropertyModel[] {
    if (!this.sort || !this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort?.direction === 'asc';
      switch (this.sort?.active) {
        case 'address': return compare(a.rentalPropertyStreetAddress?? '', b.rentalPropertyStreetAddress?? '', isAsc);
        case 'id': return compare(a.id?? 0, b.id?? 0, isAsc);
        case 'status': return compare(a.status?? '', b.status?? '', isAsc);
        default: return 0;
      }
    });
  }
}

function compare(a: string | number, b: string | number, isAsc: boolean): number {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
